import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const addCountryProgramEligibilityRules: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  eligibilityRuleCodes: string[],
  accessToken?: string,
) => Promise<void> = async (fetchContext, programId, countryId, eligibilityRuleCodes, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/eligibility-rules`,
  {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(eligibilityRuleCodes),
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'add country program eligibility rules'));
